import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./sidebar.css";
import Logo from "../../assets/logo.svg";
import LogoTopBar from "../../assets/logo-top-bar.png";
import SettingsMenu from "../settings/SettingsMenu";

const navItems = [
  { id: 'home', hash: 'home', label: 'Home', icon: 'icon-home' },
  { id: 'about', hash: 'about', label: 'Over mij', icon: 'icon-user-following' },
  { id: 'resume', hash: 'resume', label: 'CV & Ervaring', icon: 'icon-graduation' },
  { id: 'work', hash: 'work', label: 'Portfolio', icon: 'icon-layers' },
  { id: 'contact', hash: 'contact', label: 'Contact', icon: 'icon-bubble' }
];

const Sidebar = () => {
  const [toggle, showMenu] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");

    const handleScroll = () => {
      const scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop = current.offsetTop - 150;
        const sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, targetHash) => {
    showMenu(false);
    const targetElement = document.getElementById(targetHash) || (targetHash === 'portfolio' ? document.getElementById('work') : null) || (targetHash === 'work' ? document.getElementById('portfolio') : null);

    if (location.pathname === '/') {
      e.preventDefault();
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
        window.history.pushState(null, '', `/#${targetHash}`);
        setActiveSection(targetHash === 'portfolio' ? 'work' : targetHash);
      } else if (targetHash === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.history.pushState(null, '', `/#home`);
        setActiveSection('home');
      }
    } else {
      navigate(`/#${targetHash}`);
    }
  };

  return (
    <>
      <div 
        className={`nav__overlay ${toggle ? 'show-menu-overlay' : ''}`}
        onClick={() => showMenu(false)}
      ></div>

      {/* Top bar on mobile (de top bar ding) */}
      <header className="mobile-top-bar">
        <Link 
          to="/#home" 
          className="mobile-top-bar__logo" 
          onClick={(e) => handleNavClick(e, 'home')}
          title="Bram Platier"
        >
          <img src={LogoTopBar} alt="Bram Platier" />
        </Link>
        <button 
          type="button"
          className="mobile-top-bar__toggle"
          onClick={() => showMenu(!toggle)}
          aria-label="Menu openen of sluiten"
        >
          <i className={toggle ? "icon-close" : "icon-menu"}></i>
        </button>
      </header>

      {/* Bar on the left (de bar links) */}
      <aside className={toggle ? "aside show-menu" : "aside"}>
        <Link 
          to="/#home" 
          className="nav__logo" 
          onClick={(e) => handleNavClick(e, 'home')}
          title="Home"
          aria-label="Home"
        >
          <img src={Logo} alt="Logo" />
        </Link>

        <nav className="nav">
          <div className="nav__menu">
            <ul className="nav__list">
              {navItems.map((item) => {
                const isActive = activeSection === item.id || (item.id === 'work' && activeSection === 'portfolio');
                return (
                  <li className="nav__item" key={item.id}>
                    <Link
                      to={`/#${item.hash}`}
                      className={`nav__link ${isActive ? 'active' : ''}`}
                      onClick={(e) => handleNavClick(e, item.hash)}
                      aria-label={item.label}
                    >
                      <i className={item.icon}></i>
                      <span className="nav__tooltip">{item.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </nav>
        <div className="nav__footer">
          <SettingsMenu />
          <span className="copyright">
            &copy; 2026 - 2027 v1.2
          </span>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
